import { TableSector } from './table-sector.model';

export class ReservationDayWeek {
  storeId: number;
  daysList: ReservationDayHours[];
}

export class ReservationDayHours {
  id?: number;
  dayOfWeek?: string;
  enable?: boolean;
  schedule?: string;
  hours?: ReservationHourList[];

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (this.enable == null) {
      this.enable = true;
    }
    if (!this.schedule) {
      this.schedule = '';
    }
    if (!this.hours) {
      this.hours = [];
    }
  }
}

export class ReservationHourList {
  id?: number;
  reservationDaysModel?: any;
  initialTime: string;
  endTime: string;
  quantity: number;
  reservationFee?: number;
  charge: boolean;
  sectors?: TableSector[];
  approvalLimit?: number;
  minApprovalLimit?: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (!this.initialTime) {
      this.initialTime = '';
    }
    if (!this.endTime) {
      this.endTime = '';
    }
    if (this.reservationFee == null) {
      this.reservationFee = 0;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/reservation/models/reservation-day-hours-config.model.ts